import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommissionsApiService } from './commisions.api.service';
import { Cacheable } from 'ts-cacheable';
import { CACHE_KEYS } from 'src/app/helpers/Cache';

@Injectable({
  providedIn: 'root'
})
export class CommissionsService {

  constructor(private api: CommissionsApiService) {
  }

  // maxAge 30 minutes
  @Cacheable({ cacheKey: CACHE_KEYS["commissions-agent"], maxAge: 30 * 60 * 1000 })
  public getCommissionsAgent(params?): Observable<any> {
    return this.api.get(`/api/agent/commissions`, { params });
  }

  // maxAge 30 minutes
  @Cacheable({ cacheKey: CACHE_KEYS["commissions-admin"], maxAge: 30 * 60 * 1000 })
  public getCommissionsAdmin(user_id, params?): Observable<any> {
    return this.api.get(`/api/admin/commissions?user_id=${user_id}`, { params });
  }

  public getAchievedProductCommission(user_id, role_id, achieved, params): Observable<any> {
    return this.api.get(`/api/agent/commissions/product-activity`, {
      params: {
        user_id,
        role_id,
        achieved,
        ...params
      }
    });
  }


}
